<div id='pgm-icon-select-container'>
    <div *ngFor='let iIcon of pgmIcons' [ngClass]="{ 'pgm-icon-item': true, 'pgm-icon-item-selected': iIcon.id === currentIcon }" [inlineSVG]="iIcon.on" (click)='onIconSelected(iIcon.id)'></div>
</div>